function toVhVw(arg) {
    //if (arg.toString().endsWith('vw'))
    if(arg.toString()[arg.toString().length - 1] == "w")
        return ((window.innerWidth / 100) * arg.toString().split('v')[0]);
    else
        return ((window.innerHeight / 100) * arg.toString().split('v')[0]);
}

function setInputFilter(textbox, inputFilter) {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
      textbox.addEventListener(event, function() {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        } else {
          this.value = "";
        }
      });
    });
}

let General = {
    toVhVw: toVhVw,
    setInputFilter:setInputFilter
}

export default General